"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefillsPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Refills_1 = require("../../sections/refills/Refills");
const RefillsPage = ({ title }) => {
    return (0, jsx_runtime_1.jsx)(Refills_1.Refills, {});
};
exports.RefillsPage = RefillsPage;
